import { adaptFormItemResponseToFormFields } from '../core';
import { IFormBase, QuestionWithDetailsFormField } from '@/forms/typings';
import { QuestionWithDetailsFormFieldBuilder } from '@/forms/builders';
import { FormQuestionWithDetailsFieldResponseDTO } from '@/api/base/DTOs';

export const adaptFormQuestionWithDetailsFieldResponseToQuestionWithDetailsFormField =
  (
    formQuestionWithDetailsFieldResponse: FormQuestionWithDetailsFieldResponseDTO,
    parentFieldId?: IFormBase['fieldId'],
  ): QuestionWithDetailsFormField => {
    let questionWithDetailsField = new QuestionWithDetailsFormFieldBuilder()
      .fieldId(formQuestionWithDetailsFieldResponse.fieldID)
      .name(formQuestionWithDetailsFieldResponse.fieldID)
      .question(formQuestionWithDetailsFieldResponse.question)
      .answer(formQuestionWithDetailsFieldResponse.answer)
      .trueOptionText(formQuestionWithDetailsFieldResponse.trueOptionText)
      .falseOptionText(formQuestionWithDetailsFieldResponse.falseOptionText)
      .matchingAnswer(formQuestionWithDetailsFieldResponse.matchingAnswer)
      .isEditable(formQuestionWithDetailsFieldResponse.isEditable)
      .notApplicable(formQuestionWithDetailsFieldResponse.notApplicable)
      .showNotApplicable(formQuestionWithDetailsFieldResponse.showNotApplicable)
      .isRequired(formQuestionWithDetailsFieldResponse.isRequired)
      .parentFieldId(parentFieldId);

    if (formQuestionWithDetailsFieldResponse.hint) {
      questionWithDetailsField = questionWithDetailsField.hint(
        formQuestionWithDetailsFieldResponse.hint,
      );
    }

    if (formQuestionWithDetailsFieldResponse.hintImageUrl) {
      questionWithDetailsField = questionWithDetailsField.hintImageUrl(
        formQuestionWithDetailsFieldResponse.hintImageUrl,
      );
    }

    if (formQuestionWithDetailsFieldResponse.trueDetails) {
      questionWithDetailsField = questionWithDetailsField.trueDetails(
        adaptFormItemResponseToFormFields(
          formQuestionWithDetailsFieldResponse.trueDetails,
          formQuestionWithDetailsFieldResponse.fieldID,
        ),
      );
    }

    if (formQuestionWithDetailsFieldResponse.falseDetails) {
      questionWithDetailsField = questionWithDetailsField.falseDetails(
        adaptFormItemResponseToFormFields(
          formQuestionWithDetailsFieldResponse.falseDetails,
          formQuestionWithDetailsFieldResponse.fieldID,
        ),
      );
    }

    if (formQuestionWithDetailsFieldResponse.matchingDetails) {
      questionWithDetailsField = questionWithDetailsField.matchingDetails(
        adaptFormItemResponseToFormFields(
          formQuestionWithDetailsFieldResponse.matchingDetails,
          formQuestionWithDetailsFieldResponse.fieldID,
        ),
      );
    }

    return questionWithDetailsField.build();
  };
